import { useUserPreference } from '@/hooks/useUserPreference';
import type { AnnouncementId } from '../types';
import { buildDismissPreferenceKey } from '../keys';

/**
 * Hook to manage announcement dismissal state.
 * Persists dismissal to UserPreferences API.
 */
export function useAnnouncementDismiss(
  announcementId: AnnouncementId,
  displayType?: 'modal' | 'banner'
) {
  const key = buildDismissPreferenceKey(announcementId, displayType);

  const { value, setValue, isLoading } = useUserPreference<string>({
    key,
    defaultValue: 'false',
  });

  const isDismissed = value === 'true';

  const dismiss = async () => {
    try {
      await setValue('true');
    } catch (error) {
      // Swallow errors - dismissal should never block the UI
      console.error('[Announcements] Error dismissing announcement:', error);
    }
  };

  return {
    isDismissed,
    dismiss,
    isLoading,
  };
}
